import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

/**
 * EndSimulationBannerText:
 *  - Text to dispaly on EndSimulationBanner 
 */
export function EndSimulationBannerText(props) {
  const className = `${style.text} ${props.className}`;
  return <p className={className}>{props.text}</p>;
}

EndSimulationBannerText.propTypes = {
  /**
   * Text to display on the banner
   */
  text: PropTypes.string.isRequired,
  /**
   * ClassName
   */
  className: PropTypes.string,
};

EndSimulationBannerText.defaultProps = {
  className: '',
};
